module.exports = __webpack_public_path__ + "static/media/M103ws.a56752da.pdf";